// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__C_UZ5","label":"styles_label__XMNl9","image":"styles_image__EnHxd","spin":"styles_spin__TGemj"};